export const screenSizes = {
    small: 320,
    medium: 481,
    large: 769,
    extraLarge: 1025,
    extraExtraLarge: 1200,
};
